module.exports = __webpack_public_path__ + "static/media/fabric.34fb2f42.png";